// Bagel Ideas CursorEngine 2.1
// Designed and Developed by Ambrose Yeung, Founder @ Bagel Ideas

const cursorEl = document.getElementById("cursor");
const popupEl = document.getElementById("cursor-popup");

let hasMoved = false;

let mouseX = 0;
let mouseY = 0;

let popupPosX = 0;
let popupPosY = 0;
let popupTargetX = 0;
let popupTargetY = 0;

let popupHideTimeout = null;

const popupOffset = { x: 20, y: -20 };
const trailEasing = 0.15;

// Utility: detect touch devices
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

document.documentElement.classList.remove("no-js");

// If on mobile, hide cursor + popup and exit
if (isTouchDevice()) {
  if (cursorEl) cursorEl.style.display = "none";
  if (popupEl) popupEl.style.display = "none";
} else {
  // Desktop-only behavior

  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    updateCursorPosition();
    updatePopupTargetPosition();

    if (!hasMoved) {
      cursorEl.classList.add("active");
      hasMoved = true;
    }
  });

  function updateCursorPosition() {
    cursorEl.style.top = `${mouseY}px`;
    cursorEl.style.left = `${mouseX}px`;
  }

  function updatePopupTargetPosition() {
    if (popupEl.classList.contains("active")) {
      popupTargetX = mouseX + popupOffset.x;
      popupTargetY = mouseY + popupOffset.y;
    }
  }

  function snapPopupToTarget() {
    popupPosX = popupTargetX;
    popupPosY = popupTargetY;
    popupEl.style.left = `${popupPosX}px`;
    popupEl.style.top = `${popupPosY}px`;
  }

  function animatePopupPosition() {
    popupPosX += (popupTargetX - popupPosX) * trailEasing;
    popupPosY += (popupTargetY - popupPosY) * trailEasing;

    popupEl.style.left = `${popupPosX}px`;
    popupEl.style.top = `${popupPosY}px`;

    requestAnimationFrame(animatePopupPosition);
  }

  // Start animation loop
  animatePopupPosition();

  // Hover effect (event delegation supports dynamically injected [data-tag] nodes)
  document.addEventListener("mouseover", (e) => {
    const hoverTarget = e.target.closest("[data-tag]");
    if (!hoverTarget) return;
    if (hoverTarget.contains(e.relatedTarget)) return;
    if (!hasMoved) return;

    clearTimeout(popupHideTimeout);

    const hoverTag = hoverTarget.getAttribute("data-tag");
    if (hoverTag) {
      popupEl.textContent = hoverTag;

      const wasActive = popupEl.classList.contains("active");
      popupEl.classList.add("active");
      updatePopupTargetPosition();

      if (!wasActive) {
        snapPopupToTarget();
      }
    }

    cursorEl.classList.add("hover");
  });

  document.addEventListener("mouseout", (e) => {
    const hoverTarget = e.target.closest("[data-tag]");
    if (!hoverTarget) return;
    if (hoverTarget.contains(e.relatedTarget)) return;

    popupHideTimeout = setTimeout(() => {
      popupEl.classList.remove("active");
      cursorEl.classList.remove("hover");
    }, 120);
  });
}
